import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { md, lg, xl2, wide, xwide } from '../common';
import { gsap } from 'gsap';

export function initBlockLightAccentCards(parent) {
  if (!parent) return;

  const swiperEl = parent.querySelector('.block-light-accent-cards__swiper');
  if (swiperEl) {
    const pagination = swiperEl.querySelector('.swiper-pagination');
    new Swiper(swiperEl, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 20,
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        [md]: { slidesPerView: 'auto', spaceBetween: 20 },
        [lg]: { slidesPerView: 3, spaceBetween: 20 },
        [xl2]: { slidesPerView: 3, spaceBetween: 24 },
        [wide]: { slidesPerView: 3, spaceBetween: 24 },
        [xwide]: { slidesPerView: 3, spaceBetween: 32 },
      },
    });
  }

  const cards = parent.querySelectorAll('.block-light-accent-cards__item');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllLightAccentCardsBlocks() {
  const blocks = document.querySelectorAll('.js-block-light-accent-cards');
  blocks.forEach((block) => initBlockLightAccentCards(block));
}
